// extracted by mini-css-extract-plugin
export default {"wrapper":"sn-z","response":"tn-z","error":"un-z","disabled":"vn-z","buttons":"wn-z","feedbackQuestionSection":"xn-z","yesNoWrapper":"yn-z"};